import store from "../store";
import Constants from "../config/constants";

import { serviceFetchEmployeePaySlips } from "../services/Salary.service";

export const FETCH_INIT = "FETCH_INIT_SALARY_SLIPS";
export const FETCHED = "FETCHED_SALARY_SLIPS";
export const FETCHED_FAIL = "FETCHED_FAIL_SALARY_SLIPS";
export const FETCHED_FILTER = "FETCHED_FILTER_SALARY_SLIPS";
export const FETCH_NEXT = "FETCH_NEXT_SALARY_SLIPS";
export const FILTER = "FILTER_SALARY_SLIPS";
export const RESET_FILTER = "RESET_FILTER_SALARY_SLIPS";
export const SET_SORTING = "SET_SORTING_SALARY_SLIPS";
export const SET_FILTER = "SET_FILTER_SALARY_SLIPS";
export const SET_PAGE = "SET_PAGE_SALARY_SLIPS";
export const CHANGE_PAGE = "CHANGE_PAGE_SALARY_SLIPS";
export const CHANGE_STATUS = "CHANGE_STATE_SALARY_SLIPS";
export const SET_SERVER_PAGE = "SET_SERVER_PAGE_SALARY_SLIPS";
export const CREATE_DATA = "CREATE_SALARY_SLIPS";
export const UPDATE_DATA = "UPDATE_SALARY_SLIPS";
export const DELETE_ITEM = "DELETE_SALARY_SLIPS";

export function actionFetchSalarySlips(
  index = 1,
  sorting = {},
  filter = {},
  shouldReset = false
) {
  const request = serviceFetchEmployeePaySlips({
    index,
    row: sorting.row,
    order: sorting.order,
    ...filter,
  }); // GetLocation
  return (dispatch) => {
    if (shouldReset) {
      dispatch({
        type: CHANGE_PAGE,
        payload: 1,
      });
    }
    dispatch({ type: FETCH_INIT, payload: null });
    request.then((data) => {
      dispatch({ type: SET_FILTER, payload: filter });
      dispatch({ type: SET_SORTING, payload: sorting });
      if (!data.error) {
        dispatch({ type: FETCHED, payload: { data: data.data, page: index } });
        dispatch({ type: SET_SERVER_PAGE, payload: index });
        if (index == 1) {
          dispatch({ type: CHANGE_PAGE, payload: index - 1 });
        }
      } else {
        dispatch({ type: FETCHED_FAIL, payload: null });
      }
    });
  };
}



export function actionChangePageSalarySlips(page) {
  return (dispatch) => {
    dispatch({ type: CHANGE_PAGE, payload: page });
  };
}

export function actionFilterSalarySlips(value) {
  const request = null; ////serviceFetchProviderRequests(value);
  return (dispatch) => {
    dispatch({ type: FETCH_INIT, payload: null });
    request.then((data) => {
      dispatch({ type: FILTER, payload: data });
      dispatch({ type: FETCHED, payload: null });
    });
  };
}

export function actionChangeStatusSalarySlips(id, status) {
  //const request = serviceUpdateLocation({ id: params.id, status: params.type});
  return (dispatch) => {
    dispatch({ type: CHANGE_STATUS, payload: { id, status } });
  };
}

export function actionResetFilterSalarySlips() {
  return {
    type: RESET_FILTER,
    payload: null,
  };
}

export function actionSetPageSalarySlips(page) {
  const stateData = store.getState().salary;
  const currentPage = stateData.currentPage;
  const totalLength = stateData.all.length;
  const sortingData = stateData.sorting_data;
  const query = stateData.query;
  const queryData = stateData.query_data;
  const serverPage = stateData.serverPage;

  if (totalLength <= (page + 1) * Constants.DEFAULT_PAGE_VALUE) {
    store.dispatch(
        actionFetchSalarySlips(serverPage + 1, sortingData, {
        query,
        query_data: queryData,
      })
    );
  }

  console.log(currentPage, totalLength);
  return {
    type: CHANGE_PAGE,
    payload: page,
  };
}
